<template>
  <div class="mt-8 mb-8">
    <div class="text-sm text-text-ternary mb-2">
      {{ group.title }}
    </div>
    <template v-for="(expenseBudget,i) in group.childs">
      <BudgetItem v-bind="budgetExpenseProps(expenseBudget)"
                  @select="$emit('select',expenseBudget)"
                  :key="`child-${i}`"/>
    </template>
  </div>
</template>

<script>
import BudgetItem from "@/components/cabinet/Money/Budgets/BugetItem/BudgetItem";
import {mapGetters} from "vuex";

export default {
  name: "BudgetGroupItem",
  components: {BudgetItem},
  props: {
    group: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('space/budgets', ['budgetExpenseProps'])
  },
  data() {
    return {
      collapsed: false
    }
  }
}
</script>